import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";

import { UPLOAD_ACTION_OPTIONS } from "constants/constants";
import { Icon, Loader, PrimaryButton } from "widgets";
import { useSnackbarContext } from "widgets/SnackBar/SnackBar";

import FileUpload from "../../components/FileUpload/FileUpload";
import FileUploadsHistorySection from "../../components/FileUploadsHistorySection";
import UploadActionField from "../../components/UploadActionField";
import UploadInfoBanner from "../../components/UploadInfoBanner";
import UploadInfoGrid from "../../components/UploadInfoGrid";
import {
  UPLOAD_COPY,
  UPLOAD_ICONS,
} from "../../constants/uploadsContent";
import useUploadSubmit from "../../hooks/useUploadSubmit";
import {
  getScriptIdFromSearchParams,
  getUploadActionFromScriptId,
} from "../../utils/uploadsUtils";

import styles from "./UploadsContainer.module.scss";

const UploadsContainer = () => {
  const [searchParams] = useSearchParams();
  const { openSnackbar } = useSnackbarContext();
  const [selectedUploadAction, setSelectedUploadAction] = useState(() =>
    getUploadActionFromScriptId(getScriptIdFromSearchParams(searchParams))
  );
  const [selectedFile, setSelectedFile] = useState(null);

  const hasSelectedAction = Boolean(selectedUploadAction?.scriptId);

  const clearSelectedFile = () => setSelectedFile(null);

  const { handleUpload, isPending, canUpload } = useUploadSubmit({
    selectedFile,
    selectedUploadAction,
    onUploadSuccess: clearSelectedFile,
  });

  const handleUploadActionChange = (event) => {
    setSelectedUploadAction(event.target.value);
    clearSelectedFile();
  };

  return (
    <div className={styles.container}>
      <p className={styles.pageSubtitle}>{UPLOAD_COPY.PAGE_SUBTITLE}</p>

      <div className={styles.uploadCard}>
        <UploadActionField
          menuItems={UPLOAD_ACTION_OPTIONS}
          value={selectedUploadAction}
          onChange={handleUploadActionChange}
        />

        <FileUpload
          selectedFile={selectedFile}
          onFileChange={setSelectedFile}
          onFileError={(message) => openSnackbar(message, "error")}
          disabled={!hasSelectedAction}
        />

        {hasSelectedAction && selectedUploadAction.infoText ? (
          <UploadInfoBanner message={selectedUploadAction.infoText} />
        ) : null}

        <UploadInfoGrid />

        <div className={styles.cardFooter}>
          <PrimaryButton
            type="button"
            disabled={!canUpload || isPending}
            onClick={handleUpload}
          >
            {isPending ? (
              <Loader variant="inline" />
            ) : (
              <>
                <Icon name={UPLOAD_ICONS.CLOUD_UPLOAD} fontSize="small" />
                {UPLOAD_COPY.UPLOAD_BUTTON}
              </>
            )}
          </PrimaryButton>
        </div>
      </div>

      {hasSelectedAction ? (
        <div className={styles.historyCard}>
          <FileUploadsHistorySection
            key={selectedUploadAction.scriptId}
            scriptId={selectedUploadAction.scriptId}
          />
        </div>
      ) : null}
    </div>
  );
};

export default UploadsContainer;
